import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Form } from 'antd';

import { Modal } from '@/shared/ui/modal';

import type { PatternFormValues } from '../../model/types/pattern-form';
import { PatternForm } from '../pattern-form/pattern-form';

interface PatternModalProps {
    data?: PatternFormValues;
    isLoading?: boolean;
    isOpen: boolean;
    isSuccess?: boolean;
    mode: 'edit' | 'create';
    onClose: () => void;
    onSubmit: (values: PatternFormValues) => void;
}

export const PatternModal = memo((props: PatternModalProps) => {
    const { data, isLoading, isOpen, isSuccess, mode, onClose, onSubmit } =
        props;
    const { t } = useTranslation(['pattern']);
    const [form] = Form.useForm<PatternFormValues>();

    return (
        <Modal
            content={
                <PatternForm
                    data={data ?? { pattern_name: '', color: '' }}
                    form={form}
                    isLoading={isLoading ?? false}
                    isSuccess={isSuccess ?? false}
                    mode={mode}
                    onSubmit={onSubmit}
                />
            }
            isOpen={isOpen}
            onClose={onClose}
            primaryAction={{
                label: mode === 'edit' ? t('edit') : t('save'),
                callback: form.submit,
                isLoading: isLoading ?? false,
            }}
            secondaryAction={{
                label: t('cancel'),
                callback: onClose,
            }}
            title={mode === 'edit' ? t('editPattern') : t('savePattern')}
        />
    );
});

PatternModal.displayName = 'PatternModal';
